import { render, staticRenderFns } from "./TheSoundButton.vue?vue&type=template&id=18523ea8&"
import script from "./TheSoundButton.vue?vue&type=script&lang=js&"
export * from "./TheSoundButton.vue?vue&type=script&lang=js&"
import style0 from "./TheSoundButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports